// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth"; 

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA-l0gmoljBFPni9M7BiIgjIEtLCxHyIx0",
  authDomain: "villagehealth-bf8d6.firebaseapp.com",
  projectId: "villagehealth-bf8d6",
  storageBucket: "villagehealth-bf8d6.firebasestorage.app",
  messagingSenderId: "865644161915",
  appId: "1:865644161915:web:d9f1fdcd1eeeac36d9abde"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app) 
export {app, auth}; 